import $ from 'jquery';
import {tns} from 'tiny-slider/src/tiny-slider';
import 'tiny-slider/src/tiny-slider.scss';

$(document).ready(function() {
    $('.testimonialsCarousel').each(function(index, element) {
        const $element = $(element);
        const $container = $element.find('[class*="__slides"]');
        tns({
            container: $container[0],
            loop: true,
            gutter: 20,
            autoplay: false,
            autoplayButtonOutput: false,
            autoplayHoverPause: true,
            nav: true,
            navPosition: 'bottom',
            controls: true,
            controlsPosition: 'top',
            controlsText: ['', ''],
            responsive: {
                0: {
                    items: 1
                },
                960: {
                    items: 2
                }
            }
        });
    });
});